import { render } from "./SectionGallery.vue?vue&type=template&id=6ebbc332&scoped=true"
import script from "./SectionGallery.vue?vue&type=script&lang=js"
export * from "./SectionGallery.vue?vue&type=script&lang=js"

import "./SectionGallery.vue?vue&type=style&index=0&id=6ebbc332&scoped=true&lang=css"

import exportComponent from "C:\\programs\\Ar-Portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebbc332"]])

export default __exports__